module.exports = __webpack_public_path__ + "static/polygon-smart.8628af62d017658ab151de9d93f3651d.svg";